import {BrowserRouter as Router, Route, Routes, useLocation} from "react-router-dom";
import { useEffect } from "react";
import { RefreshProvider, useRefresh } from "./context/RefreshContext";
import React from "react";
import { BackendHealthProvider, useBackendHealth } from "./context/BackendHealthContext";
import MaintenancePage from "./components/MaintenancePage";
import Home from "./components/Home";
import About from "./components/About";
import Impressum from "./components/Impressum";
import Datenschutz from "./components/Datenschutz";
import AdminPanel from "./components/AdminPanel";
import AdminRoute from "./components/AdminRoute";
import Tournament from "./components/tournament/Tournaments";
import KnockoutPhase from "./components/tournament/KnockoutPhase";
import TournamentManagement from "./components/tournament/TournamentManagement";
import InvitationPage from "./components/tournament/InvitationPage";
import Navbar from "./components/Navbar";
import PwaInstallBanner from "./components/PwaInstallBanner";
import Login from "./components/Login";
import Register from "./components/Register";
import VerifyEmail from "./components/VerifyEmail";
import ChangePassword from "./components/ChangePassword";
import HeatingRoute from "./components/HeatingRoute";
import Profile from "./components/Profile";
import PrivateRoute from "./components/PrivateRoute";
import {AuthProvider} from "./context/AuthContext";
import TaskList from "./components/tasks/TaskList";
import AppointmentList from "./components/appointments/AppointmentList";
import ClubEventsPage from "./components/appointments/ClubEventsPage";
import CalendarView from "./components/calendar/CalendarView";
import BookingsOverview from "./components/bookings/BookingsOverview";
import HeatingPlan from "./components/heating/HeatingPlan";
import LeagueTeamList from "./components/league/LeagueTeamList";
import LeagueTeamDetail from "./components/league/LeagueTeamDetail";
import BockView from "./components/bock/BockView";
import WorkDutyPage from "./components/workduty/WorkDutyPage";
import WorkDutyAccountsPage from "./components/workduty/WorkDutyAccountsPage";
import WorkDutyRoute from "./components/workduty/WorkDutyRoute";
import KioskDisplay from "./components/kiosk/KioskDisplay";
import KioskConfig from "./components/kiosk/KioskConfig";
import KioskRoute from "./components/kiosk/KioskRoute";
import DrinkList from "./components/drinks/DrinkList";
import NewsList from "./components/news/NewsList";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import CourtBooking from "./components/CourtBooking";

const AppContent = () => {
  const { triggerRefresh } = useRefresh();
  // Pull‑to‑Refresh: reload page when user pulls down at top of page (mobile)
  useEffect(() => {
    let startY = 0;
    const onTouchStart = (e) => {
      // In Bereichen mit aktiver Slot-Auswahl (z.B. Match-Buchung) kein Pull-to-Refresh,
      // damit eine gerade getroffene Zeitauswahl nicht durch ein versehentliches Reload verloren geht.
      if (e.target?.closest?.('[data-no-pull-refresh]')) {
        startY = 0;
        return;
      }
      if (window.scrollY === 0) startY = e.touches[0].clientY;
    };
    const onTouchEnd = (e) => {
      if (startY) {
        const diff = e.changedTouches[0].clientY - startY;
        if (diff > 50) {
          // Trigger a full refresh to fetch latest data
          window.location.reload();
        }
        startY = 0;
      }
    };
    window.addEventListener('touchstart', onTouchStart);
    window.addEventListener('touchend', onTouchEnd);
    return () => {
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchend', onTouchEnd);
    };
  }, []);

    const location = useLocation();
    const hideNavbar = location.pathname === "/kiosk";
    return (
        <>
            {!hideNavbar && <Navbar/>}
            {!hideNavbar && <PwaInstallBanner/>}
              <div className="app-content">
            <Routes>
                <Route path="/about" element={<About/>}/>
                <Route path="/impressum" element={<Impressum/>}/>
                <Route path="/datenschutz" element={<Datenschutz/>}/>
                <Route path="/login" element={<Login/>}/>
                <Route path="/register" element={<Register/>}/>
                <Route path="/verify-email" element={<VerifyEmail/>}/>
                <Route path="/forgot-password" element={<ForgotPassword/>}/>
                <Route path="/reset-password" element={<ResetPassword/>}/>
                <Route path="/profile" element={
                    <PrivateRoute>
                        <Profile/>
                    </PrivateRoute>}
                />
                <Route path="/change-password"
                       element={<PrivateRoute>
                           <ChangePassword/>
                       </PrivateRoute>}
                />

                <Route
                    path="/admin"
                    element={<AdminRoute>
                        <AdminPanel/>
                    </AdminRoute>}
                />
                <Route path="/tournaments" element={<Tournament/>}/>
                <Route
                    path="/tournaments/manage"
                    element={<AdminRoute>
                        <TournamentManagement/>
                    </AdminRoute>}
                />
                <Route path="/knockout-phase" element={<KnockoutPhase/>}/>
                <Route path="/turnier-einladung/:token" element={<InvitationPage/>}/>
                <Route
                    path="/tasks"
                    element={<PrivateRoute>
                        <TaskList/>
                    </PrivateRoute>}
                />
                <Route
                    path="/appointments"
                    element={<PrivateRoute>
                        <AppointmentList/>
                    </PrivateRoute>}
                />
                <Route
                    path="/calendar"
                    element={<PrivateRoute>
                        <CalendarView/>
                    </PrivateRoute>}
                />
                <Route
                    path="/bookings"
                    element={<PrivateRoute>
                        <BookingsOverview/>
                    </PrivateRoute>}
                />
                <Route
                    path="/heating-plan"
                    element={<HeatingRoute>
                        <HeatingPlan/>
                    </HeatingRoute>}
                />
                <Route path="/mannschaften" element={<LeagueTeamList/>}/>
                <Route path="/mannschaften/:id" element={<LeagueTeamDetail/>}/>
                <Route
                    path="/bock"
                    element={<PrivateRoute>
                        <BockView/>
                    </PrivateRoute>}
                />
                <Route
                    path="/arbeitsdienst"
                    element={<PrivateRoute>
                        <WorkDutyPage/>
                    </PrivateRoute>}
                />
                <Route
                    path="/arbeitsdienst/konten"
                    element={<WorkDutyRoute>
                        <WorkDutyAccountsPage/>
                    </WorkDutyRoute>}
                />
                <Route
                    path="/vereinstermine"
                    element={<PrivateRoute>
                        <ClubEventsPage/>
                    </PrivateRoute>}
                />
                <Route path="/getraenke" element={<DrinkList/>}/>
                <Route path="/news" element={<NewsList/>}/>
                <Route path="/platzbuchung" element={<CourtBooking/>}/>
                <Route path="/kiosk" element={<KioskDisplay/>}/>
                <Route
                    path="/kiosk/config"
                    element={<KioskRoute>
                        <KioskConfig/>
                    </KioskRoute>}
                />
                <Route path="/" element={<Home/>}/>
            </Routes>
                </div>
        </>
    );
};

const BackendGate = ({ children }) => {
    const { status } = useBackendHealth();
    if (status === "offline") return <MaintenancePage />;
    if (status === "checking") return null;
    return children;
};

function App() {
    return (
        <BackendHealthProvider>
            <BackendGate>
                <AuthProvider>
                    <Router>
                        <RefreshProvider>
                            <AppContent/>
                        </RefreshProvider>
                    </Router>
                </AuthProvider>
            </BackendGate>
        </BackendHealthProvider>
    );
}

export default App;
